module.exports = __webpack_public_path__ + "img/box_pro_five_4.3c2c6fad.jpg";